import { AnaColumn } from "../forms-template.service";

export const CobatCer: AnaColumn[] = [
    {
      itemType: "group", colCount: "2", colSpan: "2",
      data: [
        // {type:'campo', colVisible:false, colSpan:"1", hideOnEdit:true, dataField: "id", dataType:"" , caption:"ID"},
        {
          type: 'campo', 
          disableOnUpdate: true, 
          mask: "000000", 
          dataField: "cer", 
          width: "150px",
          maxLength: "6",
          dataType: "", 
          caption: "Codice EER",
          validation: [{ type: "stringLength", max: "6", message: "Campo Obbligatorio" },
          { type: "required", message: "Campo Obbligatorio" },
          ],
        },
  
      ]
    },
    {
      itemType: "group", colCount: "1", colSpan: "2",
      data: [
        {
          type: 'campo', class: "rossa", editorType: "", dataField: "prodotto", colSpan: "2", dataType: "", caption: "Prodotto",
          validation: [{ type: "required", message: "Campo Obbligatorio" },],
        }
      ]
    },
    {
      itemType: "group", colCount: "1", colSpan: "1",
      data: [
        { type: 'campo', width: "100px", dataField: "percentuale", dataType: "", caption: "Percentuale" },
      ]
    },
    
  ]